module.exports = __webpack_public_path__ + "img/Paip Bocor Icon.da014f69.png";